export const ALERT_ICONS = {
  info: 'alert-icon-info.svg',
  success: 'alert-icon-success.svg',
  warning: 'alert-icon-error.svg',
  offer: 'alert-icon-warning.svg'
};
